export function reconcileCart(cart) {
	const items = cart.items || [];
	// Customisation rides entirely on the fee line (carries `_for_sku` +
	// `_jersey_product_id`); jersey lines are plain. The only reconciliation
	// needed: drop a fee whose paired jersey is no longer in the cart. Keep the
	// fee if the jersey matches by EITHER product_id OR sku — product_id is the
	// robust key (always present, immune to size/sku differences); sku is a
	// fallback for older fee lines without `_jersey_product_id`.
	const isFee = (i) => !!(i.properties && i.properties._for_sku);
	const productSkus = new Set(items.filter((i) => !isFee(i)).map((i) => i.sku).filter(Boolean));
	const productIds = new Set(items.filter((i) => !isFee(i)).map((i) => String(i.product_id)).filter(Boolean));

	const removeKeys = [];
	for (const i of items) {
		if (!isFee(i)) continue;
		const p = i.properties;
		const skuMatch = p._for_sku && productSkus.has(p._for_sku);
		const idMatch = p._jersey_product_id && productIds.has(String(p._jersey_product_id));
		if (!skuMatch && !idMatch) removeKeys.push(i.key);
	}
	return { removeKeys, stripKeys: [] };
}

export async function applyReconciliation(cart, fetchImpl = fetch) {
	const { removeKeys, stripKeys } = reconcileCart(cart);
	for (const key of removeKeys) {
		await fetchImpl("/cart/change.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ id: key, quantity: 0 }),
		});
	}
	for (const key of stripKeys) {
		await fetchImpl("/cart/change.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ id: key, properties: {} }),
		});
	}
	return { removeKeys, stripKeys };
}

let running = false;

export async function bootCartGuard(fetchImpl = fetch) {
	if (running) return;
	running = true;
	try {
		const res = await fetchImpl("/cart.js", { headers: { "Accept": "application/json" } });
		if (!res.ok) return;
		const cart = await res.json();
		await applyReconciliation(cart, fetchImpl);
	} finally {
		running = false;
	}
}

if (typeof document !== "undefined") {
	document.addEventListener("DOMContentLoaded", () => bootCartGuard());
	document.addEventListener("cart:updated", () => bootCartGuard());
}
